import Vue from 'vue'
import ReactiveProvide from 'vue-reactive-provide'

Vue.use(ReactiveProvide)
